export const getCounoiseFranceData = () => ({
  name: "Counoise",
  country: "France",
  description: "Counoise est un cépage rouge rare originaire du sud de la France, principalement utilisé dans les assemblages de Châteauneuf-du-Pape et d'autres appellations du Rhône méridional.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "50 ha", percentage: "2%", description: "Cépage d'assemblage rare, apportant fraîcheur et notes florales" },
    { name: "Côtes du Rhône", area: "30 ha", percentage: "1%", description: "Utilisé dans certains assemblages traditionnels" },
    { name: "Languedoc-Roussillon", area: "20 ha", percentage: "0.5%", description: "Cultivé dans quelques domaines expérimentaux" },
    { name: "Provence", area: "10 ha", percentage: "0.2%", description: "Utilisé dans certains rosés traditionnels" },
    { name: "Autres", area: "10 ha", percentage: "0.3%", description: "Dispersé dans le sud de la France" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 2 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#6d2c7a", size: 1 },
    { region: "Languedoc", x: 48, y: 62, color: "#8a4a8a", size: 1 }
  ],
  characteristics: {
    viticulture: "Cépage tardif, sensible aux maladies, nécessite des sols bien drainés",
    climate: "Préfère les climats chauds et secs du sud de la France",
    soil: "Sols calcaires et argileux, bien drainés"
  },
  wineStyles: {
    red: "Vins rouges légers à moyens, avec des notes de fruits rouges frais et d'épices douces",
    rose: "Rosés aromatiques avec des notes florales et une acidité vive"
  },
  foodPairing: "Viandes blanches, volailles, poissons, cuisine provençale, fromages frais",
  history: "Counoise est un cépage très ancien, mentionné dans les textes médiévaux. Il était autrefois plus répandu mais a été progressivement remplacé par des cépages plus productifs. Il connaît aujourd'hui un regain d'intérêt pour sa contribution unique aux assemblages."
}); 